import useUserAuthorization from '~/services/userAuthorization'

export default function ({ store, redirect, route, localePath, getRouteBaseName }) {
  const user = store.state.auth.user
  const userAuthorization = useUserAuthorization({ $auth: { user } })

  const currentRouteName = getRouteBaseName(route)
  if (!user || (!userAuthorization.canNavigateTo(currentRouteName) && currentRouteName !== 'index')) {
    redirect(localePath('/401'))
  }
}
